import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const PersonLinked = React.lazy(
  () => import('components/Person/Linked/Linked'),
);

function ScreensPersonLinked(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout>
      <DocumentTitle>Person Management</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <PersonLinked id={parseInt(params.id as string, 10)} key={params.id} />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensPersonLinked;
